import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NewCarService } from '../services/new-car.service';
import { DataService } from '../services/data.service';
import {
  bridgeUrl,
  main_site_root_url,
  setting_url_return
} from './../app.config';

@Component({
  selector: 'app-company-form',
  templateUrl: './company-form.component.html',
  styleUrls: ['./company-form.component.css']
})
export class CompanyFormComponent implements OnInit {
  public isCollapsed = true;
  public companyForm: FormGroup;
  public kyotenCd: string;
  public kyotenNm: string;
  public staffCd: string;
  public staffNm: string;
  public authShatenCd: string;
  // public authKyotenCd: string;
  public authGroupCd: string;
  public ckj_auth_token: string;
  @ViewChild('form') form;
  public extremeWebUrl = bridgeUrl + '/nkj_bridge.php';

  constructor(private newCarService: NewCarService,
    private _data: DataService
  ) {}

  ngOnInit() {
    this.kyotenCd = this._data.kyotenCd;
    this.staffCd =  this._data.staffCd;
    this.ckj_auth_token = this._data.token;
    this.newCarService.getUserInfo().subscribe(data => {
      if (data) {
        this.authShatenCd = data.shatenCd;
        // this.authKyotenCd = data.kyotenCd;
        this.authGroupCd = data.groupCd;
        this.initForm();
      }
    });

    this.initForm();
  }

  setFromAndSubmit(value: string) {
    this.companyForm.patchValue({
      target_id: value
    });
    this.form.nativeElement.submit();
  }

  initForm() {
    this.companyForm = new FormGroup({
      group_code: new FormControl(this.authGroupCd),
      company_code: new FormControl(this.authShatenCd),
      // 'company_name': new FormControl('実験社店'),
      kyoten_code: new FormControl(this.kyotenCd),
      // 'kyoten_name': new FormControl(this.kyotenNm),
      tantou_code: new FormControl(this.staffCd),
      // 'tantou_name': new FormControl(this.staffNm),
      target_id: new FormControl(''),
      // 'auth_key': new FormControl('f2c86e7324eacf1346984d91fee322c4'),
      // 'auth_date': new FormControl('20170614123012'),
      // url_return: new FormControl('http://104.198.85.214:8968/business-manage'),
      // url_toppage: new FormControl('http://104.198.85.214:8968/home'),
      url_return: new FormControl(setting_url_return),
      url_toppage: new FormControl(setting_url_return),
      ckj_auth_token: new FormControl(this.ckj_auth_token),
      main_site_root_url: new FormControl(main_site_root_url)
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/company-form/company-form.component.ts